"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBankRequest = void 0;
var CheckBankRequest = /** @class */ (function () {
    function CheckBankRequest() {
    }
    return CheckBankRequest;
}());
exports.CheckBankRequest = CheckBankRequest;
;
//# sourceMappingURL=checkBank.request.js.map